// /_chip-test — minimal reproduction page for SAB-285 Bug 1 chip-edge investigation.
// Three cases for diagnosis:
//   1. Bare minimum chip group with red debug border — proves the app shell is fine.
//   2. Same chips wrapped in MLBBeta's main wrapper — proves the page chain is fine.
//   3. Production chip group using shadcn Tabs / TabsList / TabsTrigger with the
//      EXACT classes used in MLBBetaPlayers/MLBBetaMyTeam — reproduces the bug if
//      it's specific to the Tabs primitive.
// Leave this route committed so we can re-verify on regressions.

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

const ChipTest = () => (
  <main className="min-h-screen bg-black text-white text-xs">
    {/* Case 1: bare minimum (no wrapper interference) */}
    <div className="py-2 px-2">CASE 1: bare</div>
    <div className="border border-red-500 w-full">
      <div className="flex w-full bg-blue-500">
        <button className="flex-1 bg-green-500 text-white py-2">A</button>
        <button className="flex-1 bg-yellow-500 text-black py-2">B</button>
      </div>
    </div>

    {/* Case 2: mirrors MLBBeta's main wrapper exactly */}
    <div className="py-2 px-2 mt-4">CASE 2: inside container mx-auto px-4 max-w-5xl + -mx-4</div>
    <div className="container mx-auto px-4 py-4 max-w-5xl">
      <div className="border border-red-500">
        <div className="-mx-4 sm:mx-0">
          <div className="flex w-full bg-blue-500">
            <button className="flex-1 bg-green-500 text-white py-2">A</button>
            <button className="flex-1 bg-yellow-500 text-black py-2">B</button>
          </div>
        </div>
      </div>
    </div>

    {/* Case 3: exact production code — shadcn Tabs/TabsList/TabsTrigger with the SAB-285 classes */}
    <div className="py-2 px-2 mt-4">CASE 3: shadcn Tabs + TabsList + TabsTrigger (production code)</div>
    <div className="container mx-auto px-4 py-4 max-w-5xl">
      <div className="border border-red-500">
        <Tabs defaultValue="a" className="-mx-4 sm:mx-0">
          <TabsList className="flex w-full p-0 rounded-none [&>button]:flex-1 [&>button:first-child]:rounded-l-none [&>button:last-child]:rounded-r-none sm:inline-flex sm:w-auto sm:p-1 sm:rounded-md sm:[&>button:first-child]:rounded-l-sm sm:[&>button:last-child]:rounded-r-sm sm:[&>button]:flex-initial h-8">
            <TabsTrigger value="a" className="text-xs px-2 sm:px-3 h-7">All</TabsTrigger>
            <TabsTrigger value="b" className="text-xs px-2 sm:px-3 h-7">Available</TabsTrigger>
            <TabsTrigger value="c" className="text-xs px-2 sm:px-3 h-7">Taken</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
    </div>

    {/* Case 4: same as case 3 but Tabs has w-full -mx-4 (MyTeam Roster/Trades pattern) */}
    <div className="py-2 px-2 mt-4">CASE 4: shadcn Tabs with w-full -mx-4 (MyTeam top tabs pattern)</div>
    <div className="container mx-auto px-4 py-4 max-w-5xl">
      <div className="border border-red-500">
        <Tabs defaultValue="a" className="w-full -mx-4 sm:mx-0">
          <TabsList className="flex w-full p-0 rounded-none [&>button]:flex-1 [&>button:first-child]:rounded-l-none [&>button:last-child]:rounded-r-none sm:p-1 sm:rounded-md sm:[&>button:first-child]:rounded-l-sm sm:[&>button:last-child]:rounded-r-sm">
            <TabsTrigger value="a" className="flex-1 gap-1.5">Roster</TabsTrigger>
            <TabsTrigger value="b" className="flex-1 gap-1.5">Trades</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
    </div>
  </main>
);

export default ChipTest;
